import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as o, normalizeClass as l, createElementVNode as r } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconStrikethrough",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 1.5H8a.5.5 0 1 1 0 1H4.5a1.001 1.001 0 0 0-.943 1.333.5.5 0 1 1-.943.334A2 2 0 0 1 4.5 1.5Z",
  fill: "currentColor"
}, null, -1), h = /* @__PURE__ */ r("path", {
  d: "M9.5 8A2.5 2.5 0 0 1 7 10.5H3a.5.5 0 0 1 0-1h4a1.5 1.5 0 0 0 0-3H2a.5.5 0 0 1 0-1h8a.5.5 0 1 1 0 1H9c.323.43.5.956.5 1.5Z",
  fill: "currentColor"
}, null, -1), u = [
  _,
  h
];
function m(a, f, i, p, g, e) {
  return o(), d("svg", {
    "aria-label": i.ariaLabel,
    class: l([e.iconSizeClass, "d-icon d-icon--strikethrough"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Strikethrough",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const H = /* @__PURE__ */ n(s, [["render", m]]);
export {
  H as default
};
//# sourceMappingURL=strikethrough.js.map
